<template>
  <div class="empty_box color63">暂无数据</div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.empty_box{
    display: flex;
    justify-content: center;
    height: 100px;
    width: 100%;
    align-items: center;
}
</style>